import { Component } from '@angular/core';
import { Toast, ToastrService, ToastPackage } from 'ngx-toastr';
import {
	animate,
	keyframes,
	state,
	style,
	transition,
	trigger
} from '@angular/animations';

@Component({
	selector: 'bb-toastr',
	templateUrl: './bb-toastr.component.html',
	styleUrls: ['./bb-toastr.component.scss'],
	animations: [
		trigger('flyInOut', [
			state('inactive', style({
				opacity: 0
			})),
			transition('inactive => active', animate('400ms ease-out', keyframes([
				style({
					transform: 'translate3d(-100px, 0, 0)',
					opacity: 0,
				}),
				style({
					transform: 'none',
					opacity: 1,
				}),
			]))),
			transition('active => removed', animate('400ms ease-in', keyframes([
				style({
					transform: 'none',
					opacity: 1,
				}),
				style({
					transform: 'translate3d(200px, 0, 0)',
					opacity: 0,
				}),
			]))),
		]),
	]
})
export class BbToastrComponent extends Toast {
	// constructor is only necessary when not using AoT
	constructor(
		protected toastrService: ToastrService,
		public toastPackage: ToastPackage,
	) {
		super(toastrService, toastPackage);
	}
}
